module.exports = __webpack_public_path__ + "public-ui/img/spb.d55cd040.svg";